import template from './parking-location.jade';
import items from '../../../enums/parking-location';

export default angular
    .module('cian.addForm.aboutObjectParkingLocation', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutObjectParkingLocation', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = items;
        },
        controllerAs: 'parking',
        template,
    }))
    .name;
